export default {
  appReady: false,
  debug: false,
  connected: navigator.onLine,
  domain: '',
  token: false,
  permissions: {},
  force_change_password: false,
  password_grace_period: false,
  myProfile: {},

  currencyFormat: {
    decimal: '.',
    thousands: ',',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false
  },

  paginationDefaults: {
    sortBy: 'created',
    descending: true,
    rowsPerPage: 5
  },

  errors: {},
  info: {},
  successes: {},
  persistentMessages: {},

  accountMap: [],
  accountList: [],

  accountSelected: {
    permissions: {}
  },
  accountNameSelected: '',
  terminalSelected: {},
  terminalNameSelected: '',

  terminalsCard: [],
  terminalsCardCanCharge: [],
  terminalsCardProcessors: [],
  terminalsACH: [],
  terminalsACHCanCharge: [],
  terminalsACHProcessors: [],

  waiveList: [],

  fundingPreferences: {
    dateRange: 'mtd',
    customStartDate: null,
    customEndDate: null,
    selectedMerchantKsuids: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js